import type { ReactNode } from 'react';
import { AlertTriangle, CheckCircle2, Info, OctagonAlert, Sparkles } from 'lucide-react';

const ICONS = { info: Info, warn: AlertTriangle, crit: OctagonAlert, ok: CheckCircle2, accent: Sparkles };

export function Callout({
  tone = 'info',
  title,
  children,
  icon,
  role,
}: {
  tone?: keyof typeof ICONS;
  title?: ReactNode;
  children?: ReactNode;
  icon?: ReactNode;
  role?: 'alert' | 'status';
}) {
  const Icon = ICONS[tone];
  return (
    <div className={`ui-callout ui-callout--${tone}`} role={role}>
      {icon ?? <Icon aria-hidden />}
      <div style={{ minWidth: 0, display: 'grid', gap: 2 }}>
        {title && <div className="ui-callout__title">{title}</div>}
        {children && <div className="ui-callout__body">{children}</div>}
      </div>
    </div>
  );
}
